'use client';

import { CaptionWrapper } from '@/components/ui/data-display/caption-wrapper/CaptionWrapper';
import { ImageGallery } from '@/components/ui/images/image-gallery/ImageGallery';
import { GridCol } from '@/components/ui/layouts/grids/GridCol';
import {
  captionWrapper,
  gridCol,
  imageGallery,
} from '@mage-ui/styled-system/recipes';
import { useState } from 'react';

export const ImageGalleryItem = ({ data, onClick, isThumbnail, ...props }) => {
  const [hasError, setHasError] = useState(false);

  const imagePrefix = '';

  if (!data?.fields?.img_gallery) {
    return null;
  }

  return (
    <>
      {isThumbnail ? (
        <CaptionWrapper
          caption={data?.fields?.caption}
          id={data?.meta?.id}
          className={captionWrapper({ color: 'inverted' }).root}
          {...props}
        >
          <ImageGallery
            src={
              imagePrefix +
              (data?.fields?.img_thumbnail || data?.fields?.img_gallery)
            }
            alt={data?.fields?.alt_img ?? ''}
            className={imageGallery({ shape: 'fill' })}
          />
        </CaptionWrapper>
      ) : (
        !hasError && (
          <GridCol
            className={gridCol({
              colSpanS: '6',
              colSpanM: '3',
              colSpanL: '3',
            })}
          >
            <CaptionWrapper
              caption={data?.fields?.caption}
              onClick={() => onClick?.(data)}
              {...props}
            >
              <ImageGallery
                src={imagePrefix + data?.fields?.img_gallery}
                alt={data?.fields?.alt_img ?? ''}
                sizes={{
                  width: data?.fields?.sizes?.width ?? 280,
                  height: data?.fields?.sizes?.height ?? 280,
                }}
                onError={() => setHasError(true)}
              />
            </CaptionWrapper>
          </GridCol>
        )
      )}
    </>
  );
};
